import { getNftContract, getLotteryContract, getStakeContract } from "../index";
import { STAKE_ADDRESS, STAKE_PATCH_ADDRESS, RAD_STAKE_ADDRESS } from "../constants";
import { assertWalletReady, sendContractMethod, formatTokenAmount } from "./txHelper";
import { getRusdBalance, getLpBalance, getRadBalance, getBoxBalance } from "./tokenService";


export async function fetchStakeContractInfo() {
  const [rusdBalance, lpBalance, radBalance, boxBalance] = await Promise.all([
    getRusdBalance(STAKE_PATCH_ADDRESS),
    getLpBalance(STAKE_ADDRESS),
    getRadBalance(RAD_STAKE_ADDRESS),
    getBoxBalance(RAD_STAKE_ADDRESS),
  ]);

  return {
    stakeAddress: STAKE_ADDRESS,
    stakePatchAddress: STAKE_PATCH_ADDRESS,
    radStakeAddress: RAD_STAKE_ADDRESS,
    rusdBalance: formatTokenAmount(rusdBalance),
    lpBalance: formatTokenAmount(lpBalance),
    radBalance: formatTokenAmount(radBalance),
    boxBalance: formatTokenAmount(boxBalance),
  };
}

export async function fetchAdminTargets() {
  const stake = getStakeContract();
  const nft = getNftContract();

  const [lotteryAddress, nftOwner] = await Promise.all([
    stake.methods.lotteryAddress().call(),
    nft.methods.owner().call(),
  ]);

  return {
    lottery: {
      label: "抽奖合约",
      address: lotteryAddress,
    },
    admin: {
      label: "管理员自己",
      address: nftOwner,
    },
  };
}

export async function getAdminAuthorityStatus(accountAddress) {
  if (!accountAddress) {
    return {
      isAdmin: false,
      isAuthorized: false,
    };
  }

  const nft = getNftContract();
  const nftOwner = await nft.methods.owner().call();

  const isAdmin = nftOwner?.toLowerCase() === accountAddress.toLowerCase();

  return {
    isAdmin,
    isAuthorized: isAdmin,
  };
}

export async function adminMintCard({ to, cardType, quantity }) {
  console.log({ to, cardType, quantity })
  assertWalletReady();
  const nft = getNftContract();
  const amount = Number(quantity);

  if (!to) {
    throw new Error("请选择抽奖合约地址");
  }
  if (!amount || amount <= 0) {
    throw new Error("请输入有效数量");
  }

  const method = nft.methods.adminMint(to, cardType, amount);
  return sendContractMethod(method);
}
